module.exports = __webpack_public_path__ + "static/media/app_icon.4a57412c.png";